import { matchesFieldFilter } from './data-layer-fields.js';
import { isString } from './runtime-values.js';
import type { DataFeature, DataLayer } from './data-layer.js';

export function dataFeatureSourceName(feature: DataFeature, layer?: Pick<DataLayer, 'display'>): string | null {
  const fields = layer?.display?.nameFields ?? ['name', 'title', 'label'];
  for (const field of fields) {
    const value = Object.entries(feature.properties).find(([key]) => key.toLowerCase() === field.toLowerCase())?.[1];
    if (isString(value) && value.trim()) return value.trim();
  }
  return null;
}

export function isAreaFeature(feature: DataFeature): boolean {
  return feature.geometry?.type === 'Polygon' || feature.geometry?.type === 'MultiPolygon';
}

export function visibleDataFeatures(layer: DataLayer): DataFeature[] {
  return layer.features.filter(feature => feature.visible !== false && matchesFieldFilter(feature, layer.display) && feature.image?.visible !== false && (layer.display?.showUnnamed !== false || dataFeatureSourceName(feature, layer) !== null));
}
